import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProductSection } from '../components/ProductSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FAF7F4] font-sans text-[#3D2B1F]" data-id="element-214">
      <HeroSection data-id="element-215" />
      <PainSection data-id="element-216" />
      <BenefitsSection data-id="element-217" />
      <ProductSection data-id="element-218" />
      <BonusSection data-id="element-219" />
      <TestimonialsSection data-id="element-220" />
      <FAQSection data-id="element-221" />
      <CTASection data-id="element-222" />
      <Footer data-id="element-223" />
    </div>;
}